import { render, staticRenderFns } from "./standardFeature.vue?vue&type=template&id=22d48aa6"
import script from "./standardFeature.vue?vue&type=script&lang=js"
export * from "./standardFeature.vue?vue&type=script&lang=js"
import style0 from "./standardFeature.vue?vue&type=style&index=0&id=22d48aa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports